import { useState } from 'react'
import alhuelogo from './assets/alhuelogo.png'
import Container from '@mui/material/Container';
import Typography  from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import { LoadingButton } from '@mui/lab';




export const Formulario = () => {

  const [inputValue, setInputValue] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loadingButtonState, setLoadingButtonState] = useState(false);
  const APIURL = process.env.REACT_APP_URL;


  const getClientInfo = () => ({
    userAgent: navigator.userAgent,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio,
    },
  });

  // Email validation
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Chilean phone validation (formats: +56912345678, 56912345678, 912345678)
  const isValidChilePhone = (phone) => {
    const phoneRegex = /^(\+?56)?9\d{8}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  // Check if at least one contact method is valid
  const isContactValid = () => {
    const emailValid = email.trim() !== '' && isValidEmail(email);
    const phoneValid = phone.trim() !== '' && isValidChilePhone(phone);
    return emailValid || phoneValid;
  };

  async function BuscarPatente(patenteInput){
    setLoadingButtonState(true)
    const ppu = patenteInput.toUpperCase();
    const response = await fetch(`${APIURL}/ppu/${ppu}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: email.trim() !== '' ? email.trim() : null,
            phone: phone.trim() !== '' ? phone.trim() : null,
            clientInfo: getClientInfo(),
        })
    });
    if(response){
      const data = await response.json();
      if(data){
        // Temporal fix for client momentary need to fix this later
        window.location.href =  'https://portalpago.alhuepermisos.cl/';
      }else{
        window.location.href = `https://municipalidadalhueonline.cl/pc/portal/buscar?buscar=${ppu}`;
      }
    }else{
      setError("No se pudo buscar la patente.")
    }
    setLoadingButtonState(false)
    return response;
  }

  const handleSubmit = () => {
    BuscarPatente(inputValue)
  };

  return (
    <> 
      <Container maxWidth="xl" sx={{display: "flex", flexDirection:"column", alignItems: "center", justifyContent: "center"}}>
        <Container maxWidth="xl" sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <Link href="https://municipalidadalhue.cl/portal/" sx={{width:"18%",display: "flex", alignItems: "center", justifyContent: "center"}}>
            <img alt="Alhue Logo" src={alhuelogo} width='100%'/>
          </Link>
        </Container>
        <Container maxWidth="xl" sx={{pt:5,display: "flex", flexDirection:"column", alignItems: "center", justifyContent: "center"}}>
            <Typography variant="h3" sx={{pt: 2,pb:0}}>
                Portal de permisos de circulación
            </Typography>
            <Typography variant="h6" sx={{pb:3}}>
                Ingrese su patente en mayúsculas o minúsculas, SIN guión.
            </Typography>
            <Container maxWidth="xl" sx={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2}}>
              <TextField 
                variant="outlined"
                label="Ingrese su patente"
                value={inputValue}
                inputProps={{ maxLength: 6 }}
                onChange={(e) => setInputValue(e.target.value.toUpperCase())}
                onKeyDown={(event) =>{if(event.key === 'Enter' && inputValue.length === 6 && isContactValid()){handleSubmit()}}}
                fullWidth
                sx={{ maxWidth: '400px' }}
              />
              <Typography variant="body2" sx={{pb:1, pt:1}}>
                * Debe proporcionar al menos un método de contacto válido
              </Typography>
              <TextField 
                variant="outlined"
                label="Correo electrónico"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(event) =>{if(event.key === 'Enter' && inputValue.length === 6 && isContactValid()){handleSubmit()}}}
                error={email.trim() !== '' && !isValidEmail(email)}
                helperText={email.trim() !== '' && !isValidEmail(email) ? 'Correo electrónico inválido' : ''}
                fullWidth
                sx={{ maxWidth: '400px' }}
              />
              <TextField 
                variant="outlined"
                label="Teléfono (Chile +56)"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onKeyDown={(event) =>{if(event.key === 'Enter' && inputValue.length === 6 && isContactValid()){handleSubmit()}}}
                error={phone.trim() !== '' && !isValidChilePhone(phone)}
                helperText={phone.trim() !== '' && !isValidChilePhone(phone) ? 'Formato: +56912345678 o 912345678' : 'Ejemplo: +56912345678 o 912345678'}
                fullWidth
                sx={{ maxWidth: '400px' }}
              />
            </Container>
            <LoadingButton 
              variant="contained" 
              sx={{flexDirection: 'row', px: 1,py:'1%', mt:2}} 
              onClick={() => handleSubmit()}
              disabled={inputValue.length!==6 || !isContactValid()}
              loading={loadingButtonState}
            >
              <SearchIcon/>
              <span>
                  BUSCAR
              </span>
            </LoadingButton>
            {error && <Typography variant="h7" sx={{pb:4, color:"red"}} error>{error}</Typography>}
        </Container>
      </Container>
    </>
  )

}

